import { EllipsisTooltip } from 'App/Map/PanelDetails/OverviewCharts/EllipsisTooltip'
import type { TColumn } from 'components/SummaryTable/SummaryTable.types'
import { translate } from 'i18n/i18n'
import { isNil } from 'lodash'

type TValueColumn = {
  dataIndex: string
  key?: string
  title: string
  width: number
  converter: (value: number) => { valueWithSuffix: () => string }
}

export const valueColumn = ({
  dataIndex,
  key = dataIndex,
  title,
  width,
  converter,
}: TValueColumn): TColumn => ({
  title: <EllipsisTooltip fullText={title} />,
  dataIndex,
  key,
  width,
  render: (value: number) =>
    isNil(value) ? translate.phrases.templates('-') : converter(value).valueWithSuffix(),
})
